import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxCircleFilledSvg from "@ant-design/icons-svg/es/asn/DropboxCircleFilled";
import AntdIcon from '../components/AntdIcon';
var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DropboxCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DropboxCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DropboxCircleFilled';
}
export default RefIcon;